<form [formGroup]="formGroup">
    <div class="form-row">
        <div class="form-group col-md-6">
        <label for="nome">Nome del rilievo*</label>
        <input class="form-control mt-2" maxlength="2000" id="nome" formControlName="nome" type="text">
    </div>
        <div class="form-group col-md-6">
            <div class="d-flex align-items-center">
            <label for="soggettoEsecutore" class="mb-0">Soggetto esecutore del rilievo*</label>
            <button type="button" class="btn btn-link btn-sm p-0 ml-2" aria-label="Info soggetto esecutore" tabindex="0"
                    (click)="getInfoSelected()" title="Info">
                <app-toolkit-bl-icon icon="info-circle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
            </button>
        </div>

        <input class="form-control mt-2" id="soggettoEsecutore" formControlName="soggettoEsecutore" type="text">
      <!-- avviso privacy -->
        <p class="text-danger mb-2" role="alert">
            Attenzione non inserire dati soggetti a Privacy (nomi e cognomi)
        </p>    
    </div>
        <div class="form-group col-md-6">
            <label for="dataInizioRilievo">Data inizio rilievo*</label>
            <app-toolkit-datepicker
                formControlName="dataInizioRilievo"
                [disabled]="formGroup.controls['dataInizioRilievo'].disabled">
            </app-toolkit-datepicker>
        </div>
        <div class="form-group col-md-6">
            <label for="dataFineRilievo">Data fine rilievo</label>
            <app-toolkit-datepicker
                formControlName="dataFineRilievo"
                [disabled]="formGroup.controls['dataFineRilievo'].disabled">
            </app-toolkit-datepicker>
        </div>
        <div class="form-group col-md-6">
            <label for="importo">Importo rilievo (€)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="importo" formControlName="importo" type="text">
        </div>
        <div class="form-group col-md-12">
            <label for="estremiAttoIncarico">Estremi atto di incarico per rilievo (Convenzione, incarico)</label>
            <textarea maxlength="500" class="form-control" id="estremiAttoIncarico" formControlName="estremiAttoIncarico" type="text"></textarea>
        </div>
        <div class="form-group col-md-12">
            <label for="descrizione">Descrizione rilievo*</label>
            <textarea class="form-control" id="descrizione" maxlength="2000" formControlName="descrizione"></textarea>
        </div>
    </div>
</form>